import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys, templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useUpdateDrip = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('drips/update/'), body, additional),
        onSuccess: async (response) => {
            const id = response.data.drip_id;
            queryClient.setQueryData(dripKeys.detail(id), response);
            // Versioned views (?version=N) cache under their own keys — a
            // promote/fork changes which one is draft vs current.
            await queryClient.invalidateQueries({ queryKey: dripKeys.detailRoot(id) });
            await queryClient.invalidateQueries({ queryKey: dripKeys.list() });
            await queryClient.invalidateQueries({ queryKey: dripKeys.validate(id) });
            await queryClient.invalidateQueries({ queryKey: dripKeys.versionsRoot(id) });
            // A structural save can fork a draft on an ACTIVE/PAUSED drip,
            // which clones templates from the live version into new rows for
            // that draft — the StepCanvas channel lock (useMarkTemplates)
            // needs this to notice the new rows. The template editor itself
            // does NOT depend on this settling: useDripTemplateSession does
            // its own authoritative, forced-fresh fetch on open, so it can't
            // be handed a pre-fork row regardless of how this invalidation
            // or its refetch turns out.
            await queryClient.invalidateQueries({ queryKey: templateKeys.rows({ drip_id: id }) });
        }
    });
};
export default useUpdateDrip;
